export const PATH_ALGORITHMS = {
  1: "Dijkstra's Algorithm",
  2: "A* Search",
  3: "Greedy Best-First Search",
  4: "Breadth-First Search",
  5: "Depth-First Search",
  6: "Bidirectional BFS",
};

export const PATH_ALGORITHMS_SHORT = {
  1: "Dijkstra",
  2: "A*",
  3: "Greedy",
  4: "BFS",
  5: "DFS",
  6: "Bidirectional",
};

export const MAZE_ALGORITHMS = {
  1: "Recursive Division",
  2: "Recursive Backtracking",
  3: "Kruskal's Algorithm",
  4: "Prim's Algorithm",
  5: "Binary Tree Algorithm",
};

export const INSTRUMENTS = {
  1: "Wall",
  2: "Weight",
  3: "Clear",
};
